export const HOLDER_RIGHTS = [
  'Conocer, actualizar y rectificar sus datos personales.',
  'Solicitar prueba de la autorización otorgada, salvo cuando legalmente no sea necesaria.',
  'Ser informado sobre el uso dado a sus datos personales.',
  'Presentar consultas, solicitudes o reclamos relacionados con el tratamiento de su información.',
  'Solicitar la supresión de datos personales cuando resulte legalmente procedente.',
  'Revocar la autorización cuando no exista un deber legal o contractual que impida hacerlo.',
  'Acceder gratuitamente a los datos personales que hayan sido objeto de tratamiento.',
  'Presentar quejas ante la Superintendencia de Industria y Comercio después de agotar el procedimiento correspondiente ante el responsable o encargado.',
  'Abstenerse de responder preguntas relacionadas con datos sensibles o datos de niños, niñas y adolescentes cuando su tratamiento no sea obligatorio.',
];
